import {ChangeDetectionStrategy, Component, Input, OnInit, EventEmitter, Output, OnDestroy, NgZone, ViewEncapsulation} from '@angular/core';
import {Product} from '../../../classes/product';
import {Flavours} from '../../../classes/flavour';
import {Filter} from '../../../classes/filter';
import {Cartitems} from '../../../classes/cartitems';
import {CartService} from '../../../services/cart.service';
import {ActivatedRoute, Router} from '@angular/router';
import { Http, Response } from '@angular/http';
import {CommonService} from '../../../services/common.service';
import {Brands} from '../../../classes/brands';
import {Lifestage} from '../../../classes/lifestages';
import {ProductsService} from '../../../services/products.service';
import {Pcategory} from '../../../classes/pcategory';
import {Inventory} from '../../../classes/inventory';
import {Cartitems2} from '../../../classes/cartitems';
import { MatSnackBar, MatDialog } from '@angular/material';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/map';
import { Meta } from '@angular/platform-browser';
import { MobilefilterpopupComponent } from '../../../common/mobilefilterpopup/mobilefilterpopup.component';
@Component({
  selector: 'app-single-product-list',
  templateUrl: 'product-list.component.html',
  styleUrls: ['product-list.component.css'],
})
export class ProductListComponent implements OnInit {
  check: number;

  id: number;
  status11: number;
  totalitems: number;
  citems: number;
  public brand: Brands[] ;
  public data: Product[] ;
  public owncategory: any ;
  public similercat: any;
  public namestring: any;
  status: any = {};
  stock: any= {};
  loading: any;
  cid: number;
  public pcategory: Pcategory[] ; 
  msg: any;
  action: any;
  cdata: any;
  cjson: any;
  tempcatagory: number;
  searchcategory: number;
  show= false;
  public filterarray = [];
  flavourfilterarray = [];
  lifestagefilterarray = [];
  temp: Product[];
  brand2 = [];
  flavour: Flavours[];
  lifestage: Lifestage[];
  inventory: Inventory[];
  ppinventory: Inventory[];
  /* cart*/
  uid: any;
  uname: any;
  uemail: any;
  umobile: any;
  data2: Cartitems2[];
  
  flag = 0;
  cindex: number;
  prodname: string;
  prodsku: string;
  prodprice: number;
  discount: number;
  totaldiscount: number;
  quantity: number;
  payable: number;
  tax: number;
  p = 1;
  pid: number;
  stockflag = 0;
  cflag: number;
  city_id= 1;
  product: Product[];
  qt= 1;
  searchdata: any;
  sortingorder: any;
    private backup: any;
  constructor(private route: ActivatedRoute, private router: Router,
    private cartService: CartService,  private zone: NgZone,
    private commonService: CommonService, private productsService: ProductsService,
    private snackbar: MatSnackBar, private meta: Meta, public dialog: MatDialog) {
      window.scrollTo(0, 0);
      const udata = this.commonService.getUserDataLocally();
      this.uid = udata.uid;
      this.uname = udata .uname;
      this.uemail = udata.uemail;
      this.umobile = udata.umobile;
      this.cartService.totalcartitems.subscribe(totalcartitems => {
      this.totalitems = totalcartitems
    });
    this.show = false;
    this.commonService.setMenuFlag(1);
    this.route.params.subscribe(params => {
      this.productsService.productroute.next(1);
      this.getProductInventory();
      this.loading = true;
        const id = +params['id'];
        this.id = id;
        this. namestring = params['url'];
        let re = /\-/gi;
        this.namestring = this.namestring.replace(re, ' ');
        this.cid = id;
        this.getOwncategoryDetail(this.cid)
        this.getChildCategory(this.cid);
        this.productsService.getcatProduct(this.cid)
        .subscribe(
          (data: Product[]) => {
            this.data = data;
            this.loading = false;
          });
          const title = this.meta.getTag('name=title');
          this.meta.removeTagElement(title); 
          const description = this.meta.getTag('name=description');
          this.meta.removeTagElement(description);
          this.filterarray = [];
          this.flavourfilterarray = [];
          this.lifestagefilterarray = [];
          this.check = 0;
          if ( this.id === 1) {
            this.meta.addTag({ name: 'title', content: 'Buy Dog Supplies, Food & Accessories online at best price in Bangalore' });
            this.meta.addTag({ name: 'description', content: 'Buy Dog Supplies - Dog wet Food, Dry Food, Treats, Grooming Products, Dog Beds, Dog Collars, Toys & Bowls | Best Price, Quality & Fast Delivery in Bangalore' });
          } else if ( this.id === 15) {
            this.meta.addTag({ name: 'title', content: 'Top Dry Dog Food for your Dogs and Puppies | Buy Now Online' });
            this.meta.addTag({ name: 'description', content: 'Buy Dry Dog Food online from Top brands like Pedigree, Royal Canin, Drools & more. Best Price | Best Quality | Free Shipping | Fast Delivery in Bangalore' });
          } else if ( this.id === 16) {
            this.meta.addTag({ name: 'title', content: 'Shop Wet Dog Food for Dogs and Puppies | Buy Now Online' });
            this.meta.addTag({ name: 'description', content: 'Buy Wet Dog Food online from Top brands like Pedigree, Canine Creek, Purepet & more. Best Price | Best Quality | Free Shipping | Fast Delivery in Bangalore' });
          } else if ( this.id === 17) {
            this.meta.addTag({ name: 'title', content: 'Prescription Dog Food | Prescription Diets | Shop Now' });
            this.meta.addTag({ name: 'description', content: 'Check Petcart list of Vet recommended Prescription Dog Food. Free Shipping on orders over Rs. 500 | 24 hrs Delivery in Bangalore' });
          } else if ( this.id === 6) {
            this.meta.addTag({ name: 'title', content: 'Buy Dog Treats, Biscuits & Chews online | Petcart.com' });
            this.meta.addTag({ name: 'description', content: 'Petcart has a list of Dog Treats from the Best selling brands such as Pedigree, Royal Canin, Drools, Purepet & more' });
          } else if ( this.id === 18) {
            this.meta.addTag({ name: 'title', content: 'Dog Biscuits and Cruchy Treats | Shop Now at Petcart' });
            this.meta.addTag({ name: 'description', content: 'Petcart has a Delicious Range of Dog Biscuits & Crunchy Treats from the Best selling brands from Drools and Purepet' });
          } else if ( this.id === 19) {
            this.meta.addTag({ name: 'title', content: 'Shop Dog Dental Treats online at Petcart' });
            this.meta.addTag({ name: 'description', content: 'Buy Dog Dental Treats online from Top brands like Drools, Pedigree and Twistix. Best Price | Best Quality | Free Shipping | 24 hrs delivery in Bangalore' });
          } else if ( this.id === 20) {
            this.meta.addTag({ name: 'title', content: 'Dog Soft Treats | Dog Chewy Treats | Petcart' });
            this.meta.addTag({ name: 'description', content: 'Shop on Petcart for Soft and Chewy Dog Treats for your Dog at best prices and get them home delivered' });
          } else if ( this.id === 21) {
            this.meta.addTag({ name: 'title', content: 'Buy Dog Jerky Treats at the Best Prices in Bangalore' });
            this.meta.addTag({ name: 'description', content: "Petcart's range of Soft & Chewy treats | Jerky BBQ Chicken, Grilled Liver, Roasted Lamb, Bacon & Smoked Salmon | Best Quality & Fast Delivery Guaranteed" });
          } else if ( this.id === 22) {
            this.meta.addTag({ name: 'title', content: 'Dog Natural Chews | Buy online now from Petcart' });
            this.meta.addTag({ name: 'description', content: "Checkout Petcart's range of Natural Dog Chews | Bones for Dogs | Free Shipping on orders over Rs. 500"});
          } else if ( this.id === 7) {
            this.meta.addTag({ name: 'title', content: 'Buy Dog Supplies online now from Petcart in Bangalore' });
            this.meta.addTag({ name: 'description', content: "Petcart's range of of Dog Supplies, Toys, Bowls, Accessories, Dog Bed & Mat, Grooming Products, Healthcare & Costumes" });
          } else if ( this.id === 23) {
            this.meta.addTag({ name: 'title', content: 'Dog and Puppy Toys | Shop now at Petcart' });
            this.meta.addTag({ name: 'description', content: "Checkout Petcart's range of Chew Toys, Ball Toys, Rope & Tug Toys online at Petcart | Free Shipping | 24 hrs delivery in Bangalore" });
          } else if ( this.id === 30) {
            this.meta.addTag({ name: 'title', content: 'Buy Dog Feeding Bowls online at Petcart' });
            this.meta.addTag({ name: 'description', content: 'Shop Feeding Bowls for your Pet dog & Puppy | Free Shipping on orders over Rs. 500 | Best Quality | 24 hrs delivery in Bangalore' });
          } else if ( this.id === 28) {
            this.meta.addTag({ name: 'title', content: 'Buy Dog Accessories online at the BestPrice in Bangalore' });
            this.meta.addTag({ name: 'description', content: 'Buy Dog Leashes, Collars, Harness, Muzzles, ID Tags and other Accessories online at best price in Bangalore | Petcart' });
          } else if ( this.id === 25) {
            this.meta.addTag({ name: 'title', content: 'Dog Grooming Products | Shop now at  Petcart' });
            this.meta.addTag({ name: 'description', content: 'Shop online for Pet Grooming Products such as Shampoo, Conditioners, Brush, Combs, Spray Foam and Wipes | Best Quality & Fast Delivery Guaranteed' });
          } else if ( this.id === 24) {
            this.meta.addTag({ name: 'title', content: 'Shop Dog Healthcare Products online at Petcart' });
            this.meta.addTag({ name: 'description', content: 'Buy Dog Healthcare Products Online at Petcart. Dental | Skin & Coat | Hip Care | Digestive & Urinary | Weight Control | Eye care | Ear Care | First Aid' });
          }else if ( this.id === 26) {
            this.meta.addTag({ name: 'title', content: 'Buy Dog Cleaning Products | Petcart.com' });
            this.meta.addTag({ name: 'description', content: 'Buy Dog Cleaning Products such as Diapers, Training Pads, Potty Bags, Scoppers, Deodizers & Stain Removers' });
          } else if ( this.id === 29) {
            this.meta.addTag({ name: 'title', content: 'Dog & Puppy Costumes | Shop Now at Petcart' });
            this.meta.addTag({ name: 'description', content: 'Buy Dog & Puppy Costumes online at Petcart | Dog Tshirts | Pet Dress | Shoes | Tie | Other Accesssories' });
    
          } else if ( this.id === 2) {
            this.meta.addTag({ name: 'title', content: 'Buy Cat Supplies, Food & Accessories online at best price in Bangalore' });
            this.meta.addTag({ name: 'description', content: 'Buy Cat Supplies - Cat wet Food, Dry Food, Treats, Grooming Products, Litter Trays, Toys & Accessories | Best Price, Quality & Fast Delivery in Bangalore' });
    
          }  else if ( this.id === 31) {
            this.meta.addTag({ name: 'title', content: 'Top Dry Cat Food for your Cats and Kittens | Buy Now Online' });
            this.meta.addTag({ name: 'description', content: 'Buy Dry Cat Food online from Top brands like Pedigree, Royal Canin, Drools & more. Best Price | Best Quality | Free Shipping | Fast Delivery in Bangalore' });
    
          }  else if ( this.id === 32) {
            this.meta.addTag({ name: 'title', content: 'Shop Wet Cat Food for Cats & Kittens | Buy Now Online' });
            this.meta.addTag({ name: 'description', content: 'Buy Wet Cat Food online from Top brands like Whiskas, Royal Canin, Drools & more. Best Price | Best Quality | Free Shipping | Fast Delivery in Bangalore' });
    
          } else if ( this.id === 33) {
            this.meta.addTag({ name: 'title', content: 'Prescription Cat Food | Prescription Diets | Shop Now' });
            this.meta.addTag({ name: 'description', content: 'Check Petcart list of Vet recommended Prescription Cat Food. Free Shipping on orders over Rs. 500 | 24 hrs Delivery in Bangalore' });
    
          } else if ( this.id === 9) {
            this.meta.addTag({ name: 'title', content: 'Buy Cat Soft and Chewy Treats online | Petcart.com' });
            this.meta.addTag({ name: 'description', content: 'Petcart has a list of Cat Soft & Chewy Treats from the Best selling brands such as Cataholic, Jinny & more' });
    
          } else if ( this.id === 36) {
            this.meta.addTag({ name: 'title', content: 'Cat Soft Treats | Cat Chewy Treats | Petcart' });
            this.meta.addTag({ name: 'description', content: 'Shop on Petcart for Soft and Chewy Cat Treats for your Dog at best prices and get them home delivered' });
    
          } else if ( this.id === 10) {
            this.meta.addTag({ name: 'title', content: 'Buy Cat Litter & Accessories at the Best Prices in Bangalore' });
            this.meta.addTag({ name: 'description', content: 'Buy the best  Cat Litters and Accessories Online | Best Price | Best Quality | Free and Fast delivery' });
    
          } else if ( this.id === 38) {
            this.meta.addTag({ name: 'title', content: 'Top Cat Litter for your Cats and Kittens | Shop now online' });
            this.meta.addTag({ name: 'description', content: 'Petcart has a wide range of Cat Litter. Checkout the list of Cat Litters online | Delite Cat Litter, Happy Cat Litter, Scoopable Cat Litter, Cat Litter Oudourlock & more' });
    
          } else if ( this.id === 39) {
            this.meta.addTag({ name: 'title', content: 'Cat Litter Trays online in Bangalore | Petcart' });
            this.meta.addTag({ name: 'description', content: 'Buy Cat Litter Trays online at best price in Bangalore on Petcart. Checkout Trixie Classic Cat Litter Tray with Rim' });
    
          } else if ( this.id === 41) {
            this.meta.addTag({ name: 'title', content: 'Cat Cleaners and Deodizers | Buy now online' });
            this.meta.addTag({ name: 'description', content: 'Buy Cat Litter Deodizer - available in Vanilla and Lavender Flavours | Free Shipping on orders over Rs. 500 | 24 hrs Delivery in Bangalore' });
    
          } else if ( this.id === 47) {
            this.meta.addTag({ name: 'title', content: 'Cat and Kitten Toys | Shop now at Petcart' });
            this.meta.addTag({ name: 'description', content: "Checkout Petcart's range of Chew Toys, Ball Toys, Intercative Toys, Rope & Tug Toys online at Petcart | 24 hrs delivery in Bangalore" });
    
          } else if ( this.id === 46) {
            this.meta.addTag({ name: 'title', content: 'Shop Cat Healthcare Products online at Petcart' });
            this.meta.addTag({ name: 'description', content: 'Buy Cat Healthcare Products Online at Petcart. Dental | Skin & Coat | Hip Care | Digestive & Urinary | Weight Control | Eye care | Ear Care | First Aid' });
    
          } else if ( this.id === 42) {
            this.meta.addTag({ name: 'title', content: 'Buy Cat Accessories online at the BestPrice in Bangalore' });
            this.meta.addTag({ name: 'description', content: 'Buy Dog Leashes, Collars, Harness, Muzzles, ID Tags and other Accessories online at best price in Bangalore | Petcart' });
    
          }  else {
            this.meta.addTag({ name: 'title', content: this.namestring });
            this.meta.addTag({ name: 'description', content: this.namestring });
            console.log('else');
           }
      });

    this.commonService.categoryid.next(this.cid);
  
}

ngOnInit() {
  this.getProductInventory();
this.commonService.getBrands()
    .subscribe(
      (brand: Brands[]) => {
        this.brand = brand;
       },
     );
 this.commonService.getFlavours()
    .subscribe(
      (flavour: Flavours[]) => {
        this.flavour = flavour;
      }
     );
 this.commonService.getLifestages()
    .subscribe(
      (lifestage: Lifestage[]) => {
          this.lifestage = lifestage;
         }
     );

    this.cartService.getUserCartItems(this.uid)
    .subscribe(
      (data2: Cartitems2[]) => {
       this.data2 = data2;

    },
    );
  }

  isOver(): boolean {
    return window.matchMedia(`(max-width: 960px)`).matches;
  }

  filter(e, data) {
    if (e.target.checked) {
      this.filterarray.push(data);
      console.log('hit',this.filterarray);
    }
    if ( !e.target.checked) {
      for ( let i = 0 ; i < this.filterarray.length; i++) {
        if ( this.filterarray[i] === data ) {
          this.filterarray.splice(i , 1);
        }
      }
    }
  }
 
  flavourFilter(e , data) {
    if  (e.target.checked) {
      this.flavourfilterarray.push(data);
    }
    if ( !e.target.checked ) {
      for ( let i = 0; i < this.flavourfilterarray.length; i++) {
        if (this.flavourfilterarray[i] === data) {
          this.flavourfilterarray.splice(i, 1);
        }
     }
    }
  }
lifestageFilter(e , data) {
    if (e.target.checked) {
      this.lifestagefilterarray.push(data);
    }
    if (!e.target.checked) {
      for ( let i = 0; i < this.lifestagefilterarray.length; i++) {
        if (this.lifestagefilterarray[i] === data) {
          this.lifestagefilterarray.splice(i, 1);
        }
      }
    }
  }

getRandomInt() {
    return Math.floor(Math.random() * (20000 - 5 + 1)) + 5;
  }
  randomString() {
    const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';
    const string_length = 5;
    let randomstring = '';
    for (let i = 0; i < string_length; i++) {
      const rnum = Math.floor(Math.random() * chars.length);
      randomstring += chars.substring(rnum, rnum + 1);
    }
    return randomstring;
  }

  public addToCart(name: string, sku: string, price: number, id: number, splprice) {
    this.stockflag = 0;
    this.checkStock(name, sku, price, id, splprice);
  }
  checkItems(sku) {
 if (this.data2.length > 0) {
      for (let i = 0; i < this.data2.length; i++) {
        if (this.data2[i].sku === this.prodsku) {
          this.flag = 1;
          this.cindex = i;
          console.log('if flag', this.flag);
        } 
      }
    } else {
      this.flag = 0;
      console.log('else flag', this.flag);
   }
  }

  checkStock(name, sku, price, id, splprice) {
    this.loading = true;
    this.ppinventory = [];
    this.commonService.getInventoryDetails(id, this.city_id)
    .subscribe(
      (ppinventory: Inventory[]) => {
        this.ppinventory = ppinventory;
        this.controlStockFlag(name, sku, price, id , splprice);
      });
  }

  controlStockFlag(name, sku, price, id , splprice) {
    for (let p in this.ppinventory) {
      if ( this.ppinventory[p].product_id === id && this.ppinventory[p].status === 1){
        this.stockflag = 1 ;
      }
  }
if (this.stockflag === 1) {
      this.refreshcart(name, sku, price, id, splprice);
    }else {
      this.loading = false;
      this.outofStock(id);
      this.msg = 'Item is Recently out of stock';
      this.openSnackBar();
  }
}
outofStock(id) {
  this.productOutOfStock(id);
}
  refreshcart(name: string, sku: string, price: number, id: number, splprice) {
    this.cartService.getUserCartItems(this.uid)
    .subscribe(
      (data2: Cartitems2[]) => {
        this.data2 = data2;
        this.addcart(name, sku, price, id, splprice);
      }
      );
  }

  addcart(name: string, sku: string, price: number, id: number, splprice) {
    this.pid = id;
    this.prodname = name;
    this.prodsku = sku;
    this.prodprice = price;
    if (splprice === 0) {
      this.discount = 0;
      this.totaldiscount = price;
      this.payable = price;
    }else {
      this.discount =  price - splprice;
      this.totaldiscount = splprice;
      this.payable = splprice;
    }
    this.checkItems(this.prodsku);

    this.tax = 0 ;
    if (this.flag === 0) {
      this.quantity = 1;
      this.cartService.createCart(this.pid, this.prodname, this.prodsku, this.prodprice,
         this.discount, this.totaldiscount, this.quantity, this.payable, this.tax, this.uid, this.uname)
      .subscribe(
        (data2: Cartitems2[]) => {

          this.data2 = data2;
          this.loading = false;
          this.test();
        });
    } else {
      this.quantity = this.data2[this.cindex].quantity + 1;
      this.payable = (this.data2[this.cindex].mrp - this.data2[this.cindex].discount)* this.quantity;
      this.cartService.updateCartIfPresent(this.data2[this.cindex].id, this.quantity, this.payable)
      .subscribe(
        (data2: Cartitems2[]) => {
          this.data2 = data2;
          this.loading = false;
          this.test();
        });
      }
  }

  test() {
    this.increaseCartitems();
    this.msg = 'Item is added to Your cart';
    this.openSnackBar();
   }



// tslint:disable-next-line:use-life-cycle-interface
ngOnDestroy() {
    localStorage.removeItem('currentcategory');
    this.show = false;
    this.removeFilter();
  }
  navChange() {

  }
// tslint:disable-next-line:member-ordering
@Output() navToggle = new EventEmitter<boolean>();
  navOpen() {
    this.navToggle.emit(true);
  }

 removeFilter() {
   this.filterarray = [];
   this.flavourfilterarray = [];
   this.lifestagefilterarray = [];
 }
 openSnackBar() {
  this.snackbar.open(this.msg , this.action, {
    duration: 4000,
  });
}


brandCount(id) {
  let total = 0;
  for (let i = 0; i < this.data.length ; i++) {
    if (this.data[i].brand_id == id) {
      total = total + 1;
    }
  }
  return total;
}
lifestageCount(id) {
  let total = 0;
  for (let i = 0; i < this.data.length ; i++) {
    if (this.data[i].lifestage_id == id) {
      total = total + 1;
    }
  }
  return total;
}

isbrandCheck(id) {
  for (let i = 0; i < this.filterarray.length; i++) {
    if (this.filterarray[i] === id) {
      return true;
    }
  } 
}
isFlavourCheck(id) {
  for (let i = 0; i < this.flavourfilterarray.length; i++) {
    if (this.flavourfilterarray[i] === id) {
      return true;
    }
  } 
}
isLifeCheck(id) {
  for (let i = 0; i < this.lifestagefilterarray.length; i++) {
    if (this.lifestagefilterarray[i] === id) {
      return true;
    }
  } 
}
getProductInventory(){
  this.commonService.getCityInventoryDetails(this.city_id)
  .subscribe((x) =>{
    this.inventory = x;
    this.checkStatus();
    this.check = 1;
  });
}
checkStatus(){
  for(let i= 0 ;i < this.inventory.length; i++) {
    this.status['id' + this.inventory[i].product_id] = this.inventory[i].status;
    this.stock['id' + this.inventory[i].product_id] = this.inventory[i].totalstock;
  }
}
getOwncategoryDetail(cid) {
  this.productsService.getowncategorydetail(cid)
  .subscribe(
    (x) => {
      this.owncategory = x;
    });
}
getChildCategory(pcid) {

this.productsService.getSimilerproduct(pcid)
.subscribe(
(x) => {
 
  this.similercat = x;
});
}
increaseCartitems() {
  this.totalitems = this.totalitems + 1;
  this.cartService.changeTotalCartItems(this.totalitems);
  }
  productOutOfStock(ospid) {
    this.status['id' + ospid] = 0;
    this.stock ['id' + ospid] = 0;
  }

  windowScroll(){
    window.scrollTo(0, 0);
  }

  toggleMenu() {
    const dialogRef = this.dialog.open(MobilefilterpopupComponent, {
      width: '100vw',
      height: '100vh',
      data: {set: 1, data1: this.data, brand: this.brand, flavour: this.flavour, lifestage: this.lifestage }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.length > 0 && result[0].no === 1) {
        this.filterarray = [];
        this.filterarray.push(result[0].id);
      } else if (result && result.length > 0 && result[0].no === 2) {
        this.flavourfilterarray = [];
        this.flavourfilterarray.push(result[0].id);
      } else if (result && result.length > 0 && result[0].no === 3) {
        this.lifestagefilterarray = [];
        this.lifestagefilterarray.push(result[0].id);
        } else {

     }
    });
  }
}



